import { get, post } from "@/services/axiosUitils";
import {
  IContributeGenerateQRResponse,
  IContributeGetPaymentStatusResponse,
  IContributeRequestUPICollectionResponse,
  IContributeValidateVPAResponse,
  IContributionResponse,
} from "@/utils/types/Contributions";

const base = "/nps/cra/last-transaction/";
const contributeBase = "/nps/contribution/validate-vpa/";
const contributeRequestUPICollectionBase =
  "/nps/contribution/request-upi-collect/";
const contributeGenerateQRBase = "/nps/contribution/generate-dynamic-qr/";
const contributeGetPaymentStatusBase = "/nps/contribution/payment-status/";

class ContributionService {
  listContributions = async (): Promise<IContributionResponse> => {
    return await get<IContributionResponse>(base);
  };

  ContributeValidateVPA = async (
    payload: any
  ): Promise<IContributeValidateVPAResponse> => {
    return await post<IContributeValidateVPAResponse>(contributeBase, payload);
  };

  ContributeRequestUPICollection = async (
    payload: any
  ): Promise<IContributeRequestUPICollectionResponse> => {
    return await post<IContributeRequestUPICollectionResponse>(
      contributeRequestUPICollectionBase,
      payload
    );
  };

  ContributeGenerateQR = async (
    payload: any
  ): Promise<IContributeGenerateQRResponse> => {
    return await post<IContributeGenerateQRResponse>(
      contributeGenerateQRBase,
      payload
    );
  };

  ContributeGetPaymentStatus = async (
    pranNumber: string
  ): Promise<IContributeGetPaymentStatusResponse> => {
    return await get<IContributeGetPaymentStatusResponse>(
      `${contributeGetPaymentStatusBase}?pranNumber=${pranNumber}`
    );
  };
}

export default new ContributionService();
